import Vue from 'vue'
import Router from 'vue-router'
// import official   from '@/components/OfficialwebPc'
import pchome from '@/page/webpage/pchome.vue'
import recharge from '@/page/webpage/recharge.vue'
import community from '@/page/webpage/community.vue'
import aboutus from '@/page/webpage/aboutus.vue'
import broadcasters from '@/page/webpage/broadcasters.vue'
import becomeagency from '@/page/webpage/becomeagency.vue'
import agreement from '@/page/webpage/agreement.vue'
import privacy from '@/page/webpage/privacy.vue'
import h5home from '@/page/h5page/h5home.vue'
import h5recharge from '@/page/h5page/h5recharge.vue'
// import jointwork  from '@/components/jointwork'
// import phone      from '@/components/phone'
Vue.use(Router)

export default new Router({
  routes: [{
      path: '/pchome',
      name: 'pchome',
      title: "首页",
      component: pchome
    },
    {
      path: '/recharge',
      name: 'recharge',
      title: "充值",
      component: recharge
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      title: "关于我们",
      component: aboutus
    },
    {
      path: '/community',
      name: 'community',
      title: "community",
      component: community
    },
    {
      path: '/broadcasters',
      name: 'broadcasters',
      title: "broadcasters",
      component: broadcasters
    },
    {
      path: '/becomeagency',
      name: 'becomeagency',
      title: "becomeagency",
      component: becomeagency
    },
    {
      path: '/h5home',
      name: 'h5home',
      title: "首页",
      component: h5home
    },
    {
      path: '/h5recharge',
      name: 'h5recharge',
      title: "账户充值",
      component: h5recharge
    },
    {
      path: '/agreement',
      name: 'agreement',
      title: "用户协议",
      component: agreement
    },
    {
      path: '/privacy',
      name: 'privacy',
      title: "隐私政策",
      component: privacy
    },
    // {path:'/phone',component:phone}
  ],
  scrollBehavior(to, from, savedPosition) {

    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js